import apiClient from './api';
import { Task, NewTask, UpdateTask } from '../types/task';

interface GetTasksParams {
  search?: string;
  project?: string;
  assigned_to?: string;
  status?: string;
}

const getTasks = async (params?: GetTasksParams): Promise<Task[]> => {
  const response = await apiClient.get<Task[]>('/tasks/', { params });
  return response.data;
};

const createTask = async (taskData: NewTask): Promise<Task> => {
  const response = await apiClient.post<Task>('/tasks/', taskData);
  return response.data;
};

const updateTask = async (id: number, taskData: UpdateTask): Promise<Task> => {
  const response = await apiClient.patch<Task>(`/tasks/${id}/`, taskData);
  return response.data;
};

export const taskService = {
  getTasks,
  createTask,
  updateTask,
};